import { formatNumber } from 'view/helpers/formatter_helper/formatter_helper';

// Plain ASCII hyphen shown when there is no amount to display, matching the
// sibling formatters' convention (ApplicantAtFirm.js, TruncatedText.js).
const EMPTY_AMOUNT_PLACEHOLDER = '-';
const EMPTY_AMOUNT_CLASS = 'currency-amount-empty';
const ZERO_AMOUNT = 0;

/**
 * Checks whether a formatter value carries no amount at all: null, undefined,
 * or a string that is empty or whitespace only.
 */
function isBlankAmount(value) {
	if (value === null || value === undefined) {
		return true;
	}

	return typeof value === 'string' && value.trim() === '';
}

/**
 * Renders a monetary amount as USD with two decimal places, or a dash when the
 * amount is zero or blank. Non-numeric values pass through unchanged.
 */
function CurrencyAmount(props) {
	const { text } = props;

	if (isBlankAmount(text)) {
		return <span className={EMPTY_AMOUNT_CLASS}>{EMPTY_AMOUNT_PLACEHOLDER}</span>;
	}

	const amount = Number(text);

	if (!Number.isFinite(amount)) {
		return <span>{text}</span>;
	}

	if (amount === ZERO_AMOUNT) {
		return <span className={EMPTY_AMOUNT_CLASS}>{EMPTY_AMOUNT_PLACEHOLDER}</span>;
	}

	return (
		<span>
			{formatNumber(amount, {
				style: 'currency',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			})}
		</span>
	);
}

export default CurrencyAmount;
